import { LayoutCoreActions } from '@app/core/state/actions';
import { appMenu } from '@app/shell/shared/menu.model';
import { createReducer, on } from '@ngrx/store';
import { Menu } from '@app/shell/shared/menu.model';

export interface State {
  showSidenav: boolean;
  displaySidebar: boolean;
  menu: Menu[];
}

export const INITIAL_STATE: State = {
  showSidenav: false,
  displaySidebar: true,
  menu: appMenu
};

export const reducer = createReducer(
  INITIAL_STATE,
  on(LayoutCoreActions.toggleMenu, state => ({
    ...state,
    showSidenav: !state.showSidenav
  })),
  on(LayoutCoreActions.displaySidebar, (state, { display }) => ({
    ...state,
    displaySidebar: display
  }))
);

export const getShowSidenav = (state: State) => state.showSidenav;
export const getDisplaySidebar = (state: State) => state.displaySidebar;
export const getMenu = (state: State) => state.menu;
